import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import recordingsResource from 'src/actions/ivrs/recordingsResource';
import { toastError } from 'src/actions/toast';

type AssetUrlWithMeta = {
  id: string;
  path: string;
  url: string;
  lastUpdatedAt?: string;
};

export default function useUploadRecording() {
  const dispatch = useDispatch();
  const { add } = recordingsResource.effects;
  return useCallback(
    async (recordingKey: string, file: File): Promise<AssetUrlWithMeta | undefined> => {
      const formData = new FormData();
      formData.append('key', recordingKey);
      formData.append('recording', file);

      let assetUrl;
      try {
        assetUrl = await dispatch(add({}, formData));
      } catch (e) {
        dispatch(toastError(`There was an error while transferring ${recordingKey}`));
      }
      return assetUrl;
    },
    [dispatch, add]
  );
}
